import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getUnitLabel } from "../pages/ProductDetails";

const ProductCard = ({ product }) => {
  const location = useLocation();
  const isHome = location.pathname.includes("products");
  return (
    <NavLink
      to={`/product/${product.id}/details`}
      className="h-[31.5rem] roup bg-white rounded-lg border border-gray-300 transition-all duration-500 overflow-hidden flex flex-col "
    >
      {/* Image Section */}
      <div className="relative min-h-[16rem] aspect-video bg-[#f8f6f1] overflow-hidden flex justify-center items-center">
        <img
          src={isHome ? product.images[0] : product.image[0]}
          alt={product.name}
          className="w-full h-full object-contain p-4 transition-transform duration-700"
        />
        {!product.availability && (
          <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px] flex items-center justify-center">
            <span className="bg-red-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg">
              OUT OF STOCK
            </span>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="p-4 flex flex-col flex-grow">
        <div className="mb-2">
          <h3 className="text-xl font-bold text-[#15363A] leading-tight mb-1 line-clamp-1">
            {product.name}
          </h3>
          <span className="text-[#998147] line-clamp-2 text-[11px] font-bold uppercase tracking-widest">
            {product.specification}
          </span>
        </div>

        <p className="text-gray-500 text-sm line-clamp-2 mb-2 flex-grow ">
          {product.short_description}
        </p>

        <div className="flex justify-between items-center py-2 border-t border-gray-50">
          <div className="flex justify-between items-center w-full">
            <span className="text-md font-semibold text-[#998147]">
              ${parseFloat(product.price.per_package).toFixed(2)}/
              {getUnitLabel(product.unit_type)}
            </span>
            <span className="text-base text-gray-800 ">
              ${parseFloat(product.price.per_unit).toFixed(2)}/ea
            </span>
          </div>
        </div>
        <button className="bg-[#15363A] hover:bg-[#998147] text-white p-2.5 font-bold rounded-lg transition-all duration-300 transform active:scale-90 shadow-lg shadow-gray-200">
          View Product
        </button>
      </div>
    </NavLink>
  );
};

export default ProductCard;
